import { ModeType } from '../config/app_modes'

import { getMode  } from '../config/app_config'

export const WWW_DOMAIN = "cast.kleonpro.tv"

const URLS: Record < ModeType , Record < string , string > > = {

  DEV: {
    WWW_BASE   : 'https://room.kleonpro.tv',
    API_BASE   : 'https://quartz.kleonpro.tv',
    MEDIA_BASE : 'https://emeraude.kleonpro.tv',
    ICON_BASE  : 'https://room.kleonpro.tv',
    TEST       : 'https://01hmz6fc8we4p1x6901w664n1q10-cd8f448eeecae42b0655.requestinspector.com/',
	CUSTOMER_FRONT_BASE : 'https://beta.kleonpro.tv',
	PORTAL_FRONT_BASE : 'https://kleon.tv',
	CAST_BASE : 'https://cast.kleonpro.tv',
	WWW_BETA_BASE : 'https://kleon.io',
  },
  TEST: {
    WWW_BASE   : 'https://room.kleonpro.tv',
    API_BASE   : 'https://quartz.kleonpro.tv',
    MEDIA_BASE : 'https://emeraude.kleonpro.tv',
    ICON_BASE  : 'https://room.kleonpro.tv',
    TEST       : 'https://01hmz6fc8we4p1x6901w664n1q10-cd8f448eeecae42b0655.requestinspector.com/',
	CUSTOMER_FRONT_BASE : 'https://beta.kleonpro.tv',
	PORTAL_FRONT_BASE : 'https://kleon.tv',
	CAST_BASE : 'https://cast.kleonpro.tv',
	WWW_BETA_BASE : 'https://kleon.io',
  },
  PROD: {
    WWW_BASE   : 'https://room.kleonpro.tv',
    API_BASE   : 'https://quartz.kleonpro.tv',
    MEDIA_BASE : 'https://emeraude.kleonpro.tv',
    ICON_BASE  : 'https://room.kleonpro.tv',
    TEST       : '',
	CUSTOMER_FRONT_BASE : 'https://beta.kleonpro.tv',
	PORTAL_FRONT_BASE : 'https://kleon.tv',
	CAST_BASE : 'https://cast.kleonpro.tv',
	WWW_BETA_BASE : 'https://kleon.io',
  },
  MAINTENANCE: {
    WWW_BASE   : '',
    API_BASE   : '',
    MEDIA_BASE : '',
    ICON_BASE  : '',
    TEST       : '',
	CUSTOMER_FRONT_BASE : '',
	PORTAL_FRONT_BASE : '',
	CAST_BASE : '',
	WWW_BETA_BASE : '',
  }
};

const getUrl = ( type : string      , 
                 path : string = '' ): string => {

  const mode    = getMode();
  const baseUrl = URLS[mode][type];
  
  if (!baseUrl) 
   {
    console.warn(`URL non définie pour le type ${type} en mode ${mode}`);
    return '';
   }

  return `${baseUrl}${path}`;
};

export const getApiUrl   = ( path: string ): string => getUrl ( "API_BASE"   , path );
export const getMediaUrl = ( path: string ): string => getUrl ( "MEDIA_BASE" , path );
export const getIconUrl  = ( path: string ): string => getUrl ( "ICON_BASE"  , path );


export const API_URLS: Record<string, string> = {

// Modération des commentaires

  // Candidatures de bêta-testeur (écran « Bêta-testeur » du super-admin)

  getBetaApplications           : getApiUrl ( '/api/beta_applications'                 ) ,
  acceptBetaApplication         : getApiUrl ( '/api/beta_applications/{id}/accept'     ) ,
  refuseBetaApplication         : getApiUrl ( '/api/beta_applications/{id}/refuse'     ) ,
  waitlistBetaApplication       : getApiUrl ( '/api/beta_applications/{id}/waitlist'   ) ,

  getPendingComments            : getApiUrl ( '/api/video_comments/pending'   ) ,
  moderateComment               : getApiUrl ( '/api/video_comments/moderate'  ) ,
  getVideoCommentsByVideo       : getApiUrl ( '/api/video_comments/by_video'  ) ,
  getRecentVideoComments        : getApiUrl ( '/api/video_comments/recent'    ) ,

  // Modération du chat en direct (écran Modération, admin-api ChatModerationController)

  getChatModerationChannels     : getApiUrl ( '/api/chat_moderation/channels' ) ,
  getChatModerationMessages     : getApiUrl ( '/api/chat_moderation/messages' ) ,
  decideChatMessages            : getApiUrl ( '/api/chat_moderation/decide'   ) ,
  sanctionChatAuthor            : getApiUrl ( '/api/chat_moderation/sanction' ) ,
  updateChatModerationChannel   : getApiUrl ( '/api/chat_moderation/channel'  ) ,
  getChatModerationBans         : getApiUrl ( '/api/chat_moderation/bans'     ) ,
  liftChatBan                   : getApiUrl ( '/api/chat_moderation/unban'    ) ,

  // « Monter sur le plateau » : demandes des spectateurs du portail (admin-api StageRequestController)

  getStageRequests              : getApiUrl ( '/api/stage_requests'           ) ,
  updateStageChannel            : getApiUrl ( '/api/stage_requests/channel'   ) ,
  stageRequestAction            : getApiUrl ( '/api/stage_requests/{id}/{action}' ) ,

  // Sondages en direct : panneau « Sondages » de la régie (admin-api PollController)

  getPolls                      : getApiUrl ( '/api/polls'                    ) ,
  createPoll                    : getApiUrl ( '/api/polls'                    ) ,
  pollAction                    : getApiUrl ( '/api/polls/{id}/{action}'      ) ,

  // Annonce « Je suis en direct » sur Facebook et Instagram (onglet Configuration, admin-api LiveAnnounceController)

  liveAnnounce                  : getApiUrl ( '/api/live_announce/{channelId}'      ) ,
  liveAnnounceCard              : getApiUrl ( '/api/live_announce/{channelId}/card' ) ,

  // Panneau « Mon compte » du créateur (admin-api CreatorAccountController)
  creatorAccount                : getApiUrl ( '/api/creator_account/{adminId}'          ) ,
  creatorAccountPassword        : getApiUrl ( '/api/creator_account/{adminId}/password' ) ,
  creatorAccountCredits         : getApiUrl ( '/api/creator_account/{adminId}/credits'  ) ,

  // Signalements des spectateurs (écran Modération, super-admins, admin-api ReportModerationController)

  getReports                    : getApiUrl ( '/api/report_moderation/reports' ) ,
  decideReports                 : getApiUrl ( '/api/report_moderation/decide'  ) ,

  // Gestion du chat en direct

  getChatConnections            : getApiUrl ( '/api/chat/connections'             ) ,
  disconnectChatConnection      : getApiUrl ( '/api/chat/connections/disconnect'  ) ,
  banChatConnection             : getApiUrl ( '/api/chat/connections/ban'         ) ,
  getChatBannedIps              : getApiUrl ( '/api/chat/banned_ips'              ) ,
  deleteChatBannedIp            : getApiUrl ( '/api/chat/banned_ips/delete'       ) ,



  postAdminAuthentication      : getApiUrl ( '/auth'                        ) ,
  getAdminInfoById             : getApiUrl ( '/api/admins/{id}'             ) ,
  getAdminInfosByEmail         : getApiUrl ( '/api/admins/byEmail'          ) ,
  getAdminStorageBreakdown     : getApiUrl ( '/api/admins/{id}/storage_breakdown' ) ,
  getAdmins                    : getApiUrl ( '/api/admins'          ) ,
  createAdmin                  : getApiUrl ( '/api/admins'          ) ,
  checkSlugExistenceAdmin      : getApiUrl ( '/api/admins/check_slug_existence' ) ,

  getAddressBook               : getApiUrl ( '/api/admins/{id}/address_book'  ),
  addAddressBookContact        : getApiUrl ( '/api/admins/{id}/address_book/add'  ),
  updateAddressBookContact     : getApiUrl ( '/api/admins/{id}/address_book/update'  ),
  deleteAddressBookContact     : getApiUrl ( '/api/admins/{id}/address_book/delete'  ),

  updateAdmin                  : getApiUrl ( '/api/admins/{id}/update'     ) ,
  deleteAdmin                  : getApiUrl ( '/api/admins/{id}'            ) ,
  updateAdminPhoto             : getApiUrl ( '/api/admins/{id}/photo'      ) ,
  updateAdminBanner            : getApiUrl ( '/api/admins/{id}/banner'      ) ,
  getAdminBannerFile           : getApiUrl ( '/api/admins/{id}/banner/file' ) ,
  getAdminPhotoFile            : getApiUrl ( '/api/admins/{id}/photo/file' ) ,

  incrementAdminDevicesUsed    : getApiUrl ( '/api/admins/{id}/devices/increment' ) ,
  decrementAdminDevicesUsed    : getApiUrl ( '/api/admins/{id}/devices/decrement' ) ,
  resetAdminUsageCounters      : getApiUrl ( '/api/admins/{id}/usage/reset' ) ,
  getAdminResources            : getApiUrl ( '/api/admins/{id}/resources' ) ,
  // Onglet « Événements » de la fiche créateur (2026-10-17) : liste (GET) et ajout (POST)
  adminEvents                  : getApiUrl ( '/api/admin_events' ) ,
  adminEventsContext                : getApiUrl ( '/api/admin_events/context' ) ,
  dashboardEvents               : getApiUrl ( '/api/dashboard_events' ) ,
  dashboardAnonymousVisits      : getApiUrl ( '/api/dashboard_anonymous_visits' ) ,
  getAdminResourceItems        : getApiUrl ( '/api/admins/{id}/resources/{kind}' ) ,
  getAdminAvatarModels         : getApiUrl ( '/api/admins/{id}/avatar_models' ) ,
  getAdminAvatarModelFile      : getApiUrl ( '/api/admins/{id}/avatar_models/{modelId}/file' ) ,
  createAdminActionLog         : getApiUrl ( '/api/admins/{id}/action_log' ) ,

  postAdminFrontEvent          : getApiUrl ( '/api/public/admin_front_events' ),

  // Messages à la communauté — un Superadmin écrit, tous les connectés lisent.

  getCurrentCommunityMessages  : getApiUrl ( '/api/community_messages/current'     ) ,
  postCommunityMessage         : getApiUrl ( '/api/community_messages'             ) ,
  retractCommunityMessage      : getApiUrl ( '/api/community_messages/{id}/retract' ) ,
  acknowledgeCommunityMessage  : getApiUrl ( '/api/community_messages/{id}/read'    ) ,
  getCommunityMessageReads     : getApiUrl ( '/api/community_messages/{id}/reads'   ) ,
  getSentCommunityMessages     : getApiUrl ( '/api/community_messages/sent'         ) ,

  // Statistiques V2 — diffusions des chaînes et lectures des vidéos (lecture seule).

  getStatisticsV2Live          : getApiUrl ( '/api/statistics_v2/live'                  ) ,
  getStatisticsV2LiveHistogram : getApiUrl ( '/api/statistics_v2/live/{id}/histogram'   ) ,
  getStatisticsV2Videos        : getApiUrl ( '/api/statistics_v2/videos'                ) ,
  getStatisticsV2VideoHistogram: getApiUrl ( '/api/statistics_v2/videos/{id}/histogram' ) ,
  getStatisticsV2LiveViewers   : getApiUrl ( '/api/statistics_v2/live/{id}/viewers'      ) ,
  getStatisticsV2VideoViewers  : getApiUrl ( '/api/statistics_v2/videos/{id}/viewers'     ) ,

  // Annuaire Xtream — triplets {server, username, password} déjà employés par un créateur.

  getXtreamDirectory           : getApiUrl ( '/api/xtream_directory'      ) ,
  saveXtreamDirectoryEntry     : getApiUrl ( '/api/xtream_directory'      ) ,
  deleteXtreamDirectoryEntry   : getApiUrl ( '/api/xtream_directory/{id}' ) ,

  // Réseaux sociaux — connexion par créateur (fiche créateur) et publication
  // d'une vidéo (VideoSheet2).

  getAdminSocialNetworks       : getApiUrl ( '/api/admin_social_networks'              ) ,
  deleteAdminSocialNetwork     : getApiUrl ( '/api/admin_social_networks/{id}'         ) ,
  getSocialNetworkAuthorizeUrl : getApiUrl ( '/api/social_networks/authorize_url'      ) ,
  linkInstagramViaFacebook     : getApiUrl ( '/api/social_networks/instagram/link_via_facebook' ) ,
  publishVideoToSocialNetwork  : getApiUrl ( '/api/videos/{id}/publish_to_social_network'   ) ,
  getVideoSocialNetworkPublications : getApiUrl ( '/api/videos/{id}/social_network_publications' ) ,

  // Annuaire HLS — URL de flux libres déjà employées par un créateur.

  getHlsDirectory              : getApiUrl ( '/api/hls_directory'      ) ,
  saveHlsDirectoryEntry        : getApiUrl ( '/api/hls_directory'      ) ,
  deleteHlsDirectoryEntry      : getApiUrl ( '/api/hls_directory/{id}' ) ,

  // VideoCategory

  getVideoCategories           : getApiUrl ( '/api/video_categories'        ) ,
  createVideoCategory          : getApiUrl ( '/api/video_categories'        ) ,
  patchVideoCategory           : getApiUrl ( '/api/video_categories/{id}'   ) ,
  deleteVideoCategory          : getApiUrl ( '/api/video_categories/{id}'   ) ,

  // MediaCategory

  getMediaCategories           : getApiUrl ( '/api/media_categories'        ) ,
  createMediaCategory          : getApiUrl ( '/api/media_categories'        ) ,
  patchMediaCategory           : getApiUrl ( '/api/media_categories/{id}'   ) ,
  deleteMediaCategory          : getApiUrl ( '/api/media_categories/{id}'   ) ,

  // Media — commun aux quatre types

  // Ce que la suppression fera vraiment, demandé AVANT d'afficher la confirmation.
  // Un seul point d'entrée : les quatre types de média partagent leurs identifiants.
  getMediaDeletionPlan          : getApiUrl ( '/api/medias/{id}/deletion_plan' ) ,

  // Video

  getVideoList                  : getApiUrl ( '/api/videos'                  ) ,
  getVideoById                  : getApiUrl ( '/api/videos/{id}'             ) ,
  createVideo                   : getApiUrl ( '/api/videos'                  ) ,
  patchVideo                    : getApiUrl ( '/api/videos/patch'            ) ,   // getApiUrl ( '/api/videos/{id}'             ) ,
  patchVideoVisibility          : getApiUrl ( '/api/videos/{id}/visibility'  ) ,
  deleteVideo                   : getApiUrl ( '/api/videos/{id}'             ) ,
  setVideoAvailability          : getApiUrl ( '/api/videos/set_availability' ) ,
  setVideoFeatured              : getApiUrl ( '/api/videos/set_featured' ) ,
  getViewerCreditsJournal       : getApiUrl ( '/api/viewer_credits_journal' ) ,
  retryVideoTranscoding         : getApiUrl ( '/api/videos/{id}/retryTranscoding'  ) ,
  cancelVideoTranscoding        : getApiUrl ( '/api/videos/{id}/cancelTranscoding' ) ,
  getVideoAudioTracks           : getApiUrl ( '/api/videos/{id}/audio_tracks'      ) ,
  uploadVideoChunk              : getApiUrl ( '/api/videos/uploadVideoChunk'     ) ,
  finalizeVideoUpload           : getApiUrl ( '/api/videos/finalizeVideoUpload'  ) ,
  finalizeVideoUpload2          : getApiUrl ( '/api/videos/finalizeVideoUpload2'  ) ,
  finalizeVideoFromRecording    : getApiUrl ( '/api/videos/finalizeVideoFromRecording' ) ,
  finalizeMultiviewAngles       : getApiUrl ( '/api/videos/finalizeMultiviewAngles' ) ,

  // Image

  createImage                   : getApiUrl ( '/api/images'                  ) ,
  getImageList                  : getApiUrl ( '/api/images'                  ) ,
  getImageById                  : getApiUrl ( '/api/images/{id}'             ) ,
  patchImage                    : getApiUrl ( '/api/images/patch'             ) ,
  patchImageVisibility          : getApiUrl ( '/api/images/{id}/visibility'  ) ,
  deleteImage                   : getApiUrl ( '/api/images/{id}'             ) ,
  getImageFile                  : getApiUrl ( '/api/images/{id}/file'        ) ,
  getImageUsage                 : getApiUrl ( '/api/images/{id}/usage'        ) ,
  uploadImageChunk              : getApiUrl ( '/api/images/uploadImageChunk'  ) ,
  finalizeImageUpload           : getApiUrl ( '/api/images/finalizeImageUpload' ) ,

  // Sound

  createSound                   : getApiUrl ( '/api/sounds'                  ) ,
  getSoundList                  : getApiUrl ( '/api/sounds'                  ) ,
  getSoundById                  : getApiUrl ( '/api/sounds/{id}'             ) ,
  patchSound                    : getApiUrl ( '/api/sounds/patch'             ) ,
  patchSoundVisibility          : getApiUrl ( '/api/sounds/{id}/visibility'  ) ,
  deleteSound                   : getApiUrl ( '/api/sounds/{id}'             ) ,
  getSoundFile                  : getApiUrl ( '/api/sounds/{id}/file'        ) ,
  getSoundUsage                 : getApiUrl ( '/api/sounds/{id}/usage'        ) ,
  uploadSoundChunk              : getApiUrl ( '/api/sounds/uploadSoundChunk'  ) ,
  finalizeSoundUpload           : getApiUrl ( '/api/sounds/finalizeSoundUpload' ) ,

  // Audio Slideshow

  getAudioSlideshowList         : getApiUrl ( '/api/audio_slideshows'                  ) ,
  getAudioSlideshowById         : getApiUrl ( '/api/audio_slideshows/{id}'             ) ,
  createAudioSlideshow          : getApiUrl ( '/api/audio_slideshows'                  ) ,
  patchAudioSlideshow           : getApiUrl ( '/api/audio_slideshows/patch'            ) ,
  patchAudioSlideshowVisibility : getApiUrl ( '/api/audio_slideshows/{id}/visibility'  ) ,
  deleteAudioSlideshow          : getApiUrl ( '/api/audio_slideshows/{id}'             ) ,
  retryAudioSlideshowTranscoding  : getApiUrl ( '/api/audio_slideshows/{id}/retryTranscoding'  ) ,
  cancelAudioSlideshowTranscoding : getApiUrl ( '/api/audio_slideshows/{id}/cancelTranscoding' ) ,

  // Uploading

  uploadMediaChunk              : getApiUrl ( '/api/medias/uploadMediaChunk'     ) ,

  // Transcoding

  getVideoTranscodingProgress         : getApiUrl ( '/api/public/video_transcode_progress_report/{mediaId}'             ) ,
  getSalesCampaignTranscodingProgress : getApiUrl ( '/api/public/sales_campaign_transcode_progress_report/{salesCampaignId}'             ) ,


  // videoManagment - Youtube

  getInformationsFromYoutube    : getApiUrl ( '/api/informationsFromYoutube' ),

  // videoManagment - Broadcasting
  
  createBroadcastingChannel                              : getApiUrl ( '/api/broadcasting_channels'                                ),
  getBroadcastingChannelList                             : getApiUrl ( '/api/broadcasting_channels'                                ),
  getDashboardLatest                                     : getApiUrl ( '/api/dashboard_latest'                                     ),
  getDashboardMediaboardAssets                           : getApiUrl ( '/api/dashboard_mediaboard_assets'                          ),
  getDashboardRecordings                                 : getApiUrl ( '/api/dashboard_recordings'                                 ),
  // Dashboard, onglet Chaînes (2026-10-17) : éteindre / verrouiller la chaîne d'un créateur (super-admin)
  channelModeration                                      : getApiUrl ( '/api/channel_moderation/{id}'                              ),
  channelModerationStop                                  : getApiUrl ( '/api/channel_moderation/{id}/stop'                         ),
  channelModerationLock                                  : getApiUrl ( '/api/channel_moderation/{id}/lock'                         ),
  channelModerationUnlock                                : getApiUrl ( '/api/channel_moderation/{id}/unlock'                       ),
  getDetailledBroadcastingChannelList                    : getApiUrl ( '/api/broadcasting_channels/detailled_list'                 ),
  getSummaryBroadcastingChannelList                      : getApiUrl ( '/api/broadcasting_channels/summary_list'                 ),
  getBroadcastingChannelInformations                     : getApiUrl ( '/api/broadcasting_channels/{id}'                           ),
  getBroadcastingChannelProcessStatus                    : getApiUrl ( '/api/broadcasting_channels/{id}/processStatus'             ),
  deleteBroadcastingChannel                              : getApiUrl ( '/api/broadcasting_channels/{id}'                           ),
  getBroadcastingChannel                                 : getApiUrl ( '/api/broadcasting_channels/{id}'                           ),
  patchBroadcastingChannel                               : getApiUrl ( '/api/broadcasting_channels/patch'                          ),// getApiUrl ( '/api/broadcasting_channels/{id}'                          ),
  uploadPendingSoundChunk                                : getApiUrl ( '/api/broadcasting_channels/uploadPendingSoundChunk'        ),
  finalizePendingSoundUpload                             : getApiUrl ( '/api/broadcasting_channels/finalizePendingSoundUpload'     ),
  patchBroadcastingChannelVisibility                     : getApiUrl ( '/api/broadcasting_channels/{id}/visibility'                ),
  showBroadcastingChannelOnPublicPortal                  : getApiUrl ( '/api/broadcasting_channels/{id}/showOnPublicPortal'        ),
  hideBroadcastingChannelFromPublicPortal                : getApiUrl ( '/api/broadcasting_channels/{id}/hiddenOnPublicPortal'       ),
  getBroadcastingChannelMetricsStatus                    : getApiUrl ( '/api/broadcasting_channels/{id}/metrics/status'            ),
  startBroadcastingChannelMetrics                        : getApiUrl ( '/api/broadcasting_channels/{id}/metrics/start'             ),
  stopBroadcastingChannelMetrics                         : getApiUrl ( '/api/broadcasting_channels/{id}/metrics/stop'              ),
  activateBroadcastingChannelInternalStreamingService    : getApiUrl ( '/api/broadcasting_channels/{id}/activation'                ),
  desactivateBroadcastingChannelInternalStreamingService : getApiUrl ( '/api/broadcasting_channels/{id}/desactivation'             ),
  regenerateBroadcastingChannelRtmpCredentials          : getApiUrl ( '/api/broadcasting_channels/{id}/rtmp_credentials'          ),
  controlBroadcastingChannelThirdPartyStreamingService   : getApiUrl ( '/api/broadcasting_channels/{id}/thirdPartyStreamingSystem' ),
  toggleBroadcastingChannelLiveService                   : getApiUrl ( '/api/broadcasting_channels/{id}/liveService'               ),
  toggleBroadcastingChannelStreamSource                  : getApiUrl ( '/api/broadcasting_channels/{id}/streamSource'              ),
  toggleBroadcastingChannelMultiview                     : getApiUrl ( '/api/broadcasting_channels/{id}/multiview'                 ),
  updateBroadcastingChannelMultiviewAngles               : getApiUrl ( '/api/broadcasting_channels/{id}/multiviewAngles'           ),
  checkExistenceBroadcastingChannel                      : getApiUrl ( '/api/broadcasting_channels/check_existence'                ),
  getCurrentAndNextBroadcastedMedias                     : getApiUrl ( '/api/broadcasting_channels/{id}/current_and_next'          ),
  getXtreamConnectionCount                               : getApiUrl ( '/api/broadcasting_channels/{id}/xtream_connection_count'   ),
  getXtreamConnectionLocations                           : getApiUrl ( '/api/broadcasting_channels/{id}/xtream_connection_locations' ),
  getBroadcastingChannelMireFonts                        : getApiUrl ( '/api/broadcasting_channels/mire_fonts'                     ),
  panicShutdownAllBroadcastingChannels                   : getApiUrl ( '/api/broadcasting_channels/panic'                        ),
  panicStatusBroadcastingChannels                        : getApiUrl ( '/api/broadcasting_channels/panic_status'                 ),

  getThirdPartyStreamingServices                         : getApiUrl ( '/api/third_party_streaming_services' ),
  getThirdPartyStreamingChannels                         : getApiUrl ( '/api/third_party_streaming_channels' ),
  createThirdPartyStreamingChannel                       : getApiUrl ( '/api/third_party_streaming_channels' ),
  updateThirdPartyStreamingChannel                       : getApiUrl ( '/api/third_party_streaming_channels/{id}' ),
  deleteThirdPartyStreamingChannel                       : getApiUrl ( '/api/third_party_streaming_channels/{id}' ),
  switchThirdPartyStreamingChannelStatus                 : getApiUrl ( '/api/third_party_streaming_channels/stateSwitching' ),

  // BroadcastingChannelCategory

  getBroadcastingChannelCategories           : getApiUrl ( '/api/broadcasting_channel_categories'        ) ,
  createBroadcastingChannelCategory          : getApiUrl ( '/api/broadcasting_channel_categories'        ) ,
  patchBroadcastingChannelCategory           : getApiUrl ( '/api/broadcasting_channel_categories/{id}'   ) ,
  deleteBroadcastingChannelCategory          : getApiUrl ( '/api/broadcasting_channel_categories/{id}'   ) ,


// Recording sessions
ensureChannelProvisionedForRecording: getApiUrl('/api/broadcasting_channels/{channelUuid}/recording/ensure_provisioned'),
startChannelRecordingSession : getApiUrl('/api/broadcasting_channels/{channelUuid}/recording/start'   ),
stopChannelRecordingSession  : getApiUrl('/api/broadcasting_channels/{channelUuid}/recording/stop'    ),
listChannelRecordingSessions : getApiUrl('/api/broadcasting_channels/{channelUuid}/recording/sessions'),
deleteChannelRecordingSession: getApiUrl('/api/broadcasting_channels/{channelUuid}/recording/sessions/{sessionId}'),
renameChannelRecordingSession: getApiUrl('/api/broadcasting_channels/{channelUuid}/recording/sessions/{sessionId}/rename'),
// Paths d'angles (multi-angle) : créés avant le start pour que la régie y publie ses
// sources en WHIP, détruits par le stop. Le DELETE n'est qu'un rattrapage.
channelRecordingAngle        : getApiUrl('/api/broadcasting_channels/{channelUuid}/recording/angles/{angleId}'),

  // videoManagment - BroadcastedMedia

  getBroadcastedMediaList:                getApiUrl('/api/broadcasted_media'),
  addBroadcastedMedia:                    getApiUrl('/api/broadcasted_media'),
  deleteBroadcastedMedia:                 getApiUrl('/api/broadcasted_media/{id}'),
  updateBroadcastedMedia:                 getApiUrl('/api/broadcasted_media/{id}'),
  setBroadcastedMediaLoop:                getApiUrl('/api/broadcasted_media/{id}/loop'),
  archiveBroadcastedMedia:                getApiUrl('/api/broadcasted_media/{id}/archive'),



  // getBroadcastingChannelStatistics:       getApiUrl('/api/public/broadcasting-channel-statistics'),


  // userManagment

  getUserList                     : getApiUrl ( '/api/users'                           ) ,
  createUser                      : getApiUrl ( '/api/users'                           ) ,
  getUserListByStatusChange       : getApiUrl ( '/api/users_by_status_change'          ) ,
  getUserCountByStatus            : getApiUrl ( '/api/users_count_by_status'           ) ,
  getUserStatusChange             : getApiUrl ( '/api/users_status_change'             ) ,
  getUserAuthenticationResultList : getApiUrl ( '/api/user_authentication_result_list' ) ,
  getUserByEmail                  : getApiUrl ( '/api/users/infos_by_email'            ) ,
  getUserById                     : getApiUrl ( '/api/users/{id}'                      ) ,
  getUserExistenceCheck           : getApiUrl ( '/api/users/existence_check'           ) ,
  patchUser                       : getApiUrl ( '/api/users/patch'                     ) , // ( '/api/users/{id}'                     ) ,
  getUserStatusList               : getApiUrl ( '/api/user_statuses'                   ) ,
  lockUser                        : getApiUrl ( '/api/users/{id}/lock'                 ) , // ( '/api/users/{id}'                     ) ,
  unlockUser                      : getApiUrl ( '/api/users/{id}/unlock'               ) , // ( '/api/users/{id}'                     ) ,
  deleteUser                      : getApiUrl ( '/api/users/{id}'                      ) ,

  

  
  // productManagment - ProductCategory

  getProductCategories         : getApiUrl ( '/api/product_categories'        ) ,
  createProductCategory        : getApiUrl ( '/api/product_categories'        ) ,
  patchProductCategory         : getApiUrl ( '/api/product_categories/{id}'   ) ,
  deleteProductCategory        : getApiUrl ( '/api/product_categories/{id}'   ) ,

  // productManagment

  getProducts                  : getApiUrl ( '/api/products'   ) ,
  createProduct                : getApiUrl ( '/api/products'   ) ,
  patchProduct                 : getApiUrl ( '/api/products/patch' ) , //( '/api/products/{id}'             ) ,
  patchProductVisibility             : getApiUrl ( '/api/products/{id}/visibility'  ) ,
  deleteProduct                      : getApiUrl ( '/api/products/{id}'             ) ,
  getProductAndVariantExistenceCheck : getApiUrl ( '/api/products/existenceCheck'   ) ,
  postProductVariantCreatePaypalPlan : getApiUrl ( '/api/product_variants/{id}/create_paypal_plan' ) ,
  
  // salesCampaignManagment

  getSalesCampaigns            : getApiUrl ( '/api/sales_campaigns'   ) ,
  createSalesCampaign          : getApiUrl ( '/api/sales_campaigns'   ) ,
  getSalesActions              : getApiUrl ( '/api/sales_actions'   ) ,
  patchSalesCampaign           : getApiUrl ( '/api/sales_campaigns/patch'  ) ,
  patchSalesCampaignVisibility : getApiUrl ( '/api/sales_campaigns/{id}/visibility'  ) ,
  deleteSalesCampaign          : getApiUrl ( '/api/sales_campaigns/{id}'             ) ,
  transcodeSalesCampaign       : getApiUrl ( '/api/sales_campaigns/{id}/transcode'   ) ,
  getSalesCampaignArchive      : getApiUrl ( '/api/sales_campaigns/{id}/getLastArchive' ) ,
  createSalesActionVideo       : getApiUrl ( '/api/sales_actions/video'   ) ,
  createSalesCampaignVideo     : getApiUrl ( '/api/sales_campaigns/video'   ) ,
 
  // adsCampaignManagment

  getAdsCampaigns            : getApiUrl ( '/api/ads_campaigns'   ) ,
  createAdsCampaign          : getApiUrl ( '/api/ads_campaigns'   ) ,
  patchAdsCampaign           : getApiUrl ( '/api/ads_campaigns/patch'  ) ,
  patchAdsCampaignVisibility : getApiUrl ( '/api/ads_campaigns/{id}/visibility'  ) ,
  deleteAdsCampaign          : getApiUrl ( '/api/ads_campaigns/{id}'             ) ,

  // keywordManagment

  getKeywords                  : getApiUrl ( '/api/keywords'   ) ,
  createKeyword                : getApiUrl ( '/api/keywords'   ) ,
  deleteKeyword                : getApiUrl ( '/api/keywords/{id}'   ) ,




  getCustomerFrontEvents       : getApiUrl ( '/api/customer_front_events'   ) ,
  getHeartBeatCount            : getApiUrl ( '/api/public/heart_beat_count'   ) ,

 //

 
  getDetailledIpAddressInformationsWithIp:      getApiUrl('/api/detailed_ip_address_informations_with_ip'),
  getDetailledIpAddressInformationsWithDate:    getApiUrl('/api/detailed_ip_address_informations_with_date'),
  getDetailledIpAddressInformations:            getApiUrl('/api/detailed_ip_address_informations'),


  getPaymentList: getApiUrl('/api/restricted/payment_list'),
  getPaymentTurnoverAndPaymentCount: getApiUrl('/api/restricted/turnover_and_payment_count'),
  getPaymentTurnoverAndPaymentCountByDate: getApiUrl('/api/restricted/turnover_and_payment_count_by_date'),

  // purchaseManagment — panier du créateur connecté (achats, cf. dataTypes/purchaseManagment)

  getPurchaseInfosByEmail:      getApiUrl('/api/purchase_infos_by_email'),
  patchAddItemToCart:           getApiUrl('/api/purchases/{id}/add_item'),
  patchRemoveItemFromCart:      getApiUrl('/api/purchases/{id}/remove_item'),
  patchChangeQuantityOfItem:    getApiUrl('/api/purchases/{id}/change_quantity_of_item'),
  postPaymentCreation:          getApiUrl('/api/payments'),

  // subscriptionManagment — abonnements récurrents du créateur connecté (quota créateur
  // acheté en mode abonnement, cf. dataTypes/subscriptionManagment)

  getSubscriptionInfosByEmail:  getApiUrl('/api/subscription_infos_by_email'),
  postSubscriptionCreation:     getApiUrl('/api/subscriptions'),
  postCancelSubscription:       getApiUrl('/api/subscriptions/{id}/cancel'),

  // sentEmailManagment — emails envoyés au créateur connecté (pas de table en base,
  // cf. dataTypes/sentEmailManagment)

  getSentEmailsByEmail:         getApiUrl('/api/sent_emails_by_email'),
  getAdminActionLogList:        getApiUrl('/api/admin_action_log_list'),

  getCompanyInfosFromSiren:            getApiUrl('/public/third_part_api/companyInfosFromSiren/{siren}'),
  getGeolocationFromIpAddress:         getApiUrl('/public/third_part_api/geolocationFromIpAddress/{ipAddress}'),
  getGeolocationFromPostalAddress:     getApiUrl('/public/third_part_api/geolocationFromPostalAddress/{postalAddress}'),

  getLegalStructures:            getApiUrl('/api/legal_structures'),
  createLegalStructure:            getApiUrl('/api/legal_structures'),

  // Configuration

  getConfiguration              : getApiUrl ( '/api/configurations/1' ) ,
  patchConfiguration            : getApiUrl ( '/api/configurations/1' ) ,
  

  getDocuments: getApiUrl ( '/api/documents'),
  getDocument: getApiUrl ( '/api/documents/{id}'),
  createDocument: getApiUrl ( '/api/documents'),
  updateDocument: getApiUrl ( '/api/documents/update'),
  deleteDocument: getApiUrl ( '/api/documents'),
  deleteDocuments: getApiUrl ( '/api/documents/batch'),
  getDocumentDownload: getApiUrl ( '/api/documents/download'),
  getDocumentFile: getApiUrl ( '/api/documents/{id}/file'),
  uploadDocumentChunk: getApiUrl ( '/api/documents/upload/chunk'),
  finalizeDocumentUpload:getApiUrl (  '/api/documents/upload/finalize'),
  markDocumentUploaded: getApiUrl ( '/api/documents/mark-uploaded'),

  createUuid: getApiUrl ( '/api/public/uuid_fabric/create'),

  postRemoteDeviceInformationsNotification : getApiUrl ( '/api/remote_device_informations_notifications'   ) ,
  postRtmpCameraInformationsNotification   : getApiUrl ( '/api/rtmp_camera_informations_notifications'     ) ,
  postWebTvInvitationNotification : getApiUrl ( '/api/web_tv_informations_notifications' ),  

  saveRegieConfig  : getApiUrl ( '/api/regie_configs'   ) ,
  getRegieConfigs  : getApiUrl ( '/api/regie_configs'   ) ,
  deleteRegieConfig:  getApiUrl ( '/api/regie_configs/{id}'   ) ,
  updateRegieConfig:  getApiUrl ( '/api/regie_configs/{id}'   ) ,
  uploadRegieMediaChunk : getApiUrl ( '/api/regie_configs/media/upload_chunk'   ),
  finalizeRegieMediaUpload : getApiUrl ( '/api/regie_configs/media/finalize'   ),
  exportRegieConfigZip : getApiUrl ( '/api/regie_configs/{id}/export_zip'   ),
  downloadRegieMedia : getApiUrl ( '/api/regie_configs/{id}/media'   ),

  // Modèles 3D de l'effet Avatar (workingSpace du créateur de la chaîne, cf. AvatarModelController)
  avatarModels        : getApiUrl ( '/api/avatar_models'              ),
  avatarModelFile     : getApiUrl ( '/api/avatar_models/{id}/file'    ),
  avatarModelDelete   : getApiUrl ( '/api/avatar_models/{id}'         ),


  remoteLog: getApiUrl ( '/api/remote_logs'   ),


  // postUser: getApiUrl('/api/public/users'),
  postAuthenticationResult      : getApiUrl ( '/api/public/authentication_result' ) ,
  postEmailValidationResend     : getApiUrl ( '/api/public/email_validation_resend' ) ,
  getPasswordResetRequest       : getApiUrl ( '/api/public/password_reset_request' ) ,
  // patchUserInformations: getApiUrl('/api/restricted/users/{id}'),
  // getUserInfosByEmail: getApiUrl('/api/restricted/user_infos_by_email'),
  // getUserExistenceCheck: getApiUrl('/api/public/user_existence_check'),
  // getUserEmailValidation: getApiUrl('/api/public/email_validation'),
  // getUserEmailValidationCheck: getApiUrl('/api/restricted/email_validation_check'),
  // getUserPasswordResetRequest: getApiUrl('/api/public/password_reset_request'),
  // getUserPasswordReset: getApiUrl('/api/public/password_reset'),
  // getUserEmailResetRequest: getApiUrl('/api/restricted/email_reset_request'),
  // getUserEmailReset: getApiUrl('/api/public/email_reset'),
  
  // getUserListFile: getApiUrl('/api/restricted/user_list_file'),

  // Paiements
  // postPayment: getApiUrl('/api/restricted/payments'),
  // getPaymentInfosByEmail: getApiUrl('/api/restricted/payment_infos_by_email'),
  // getPaymentList: getApiUrl('/api/restricted/payment_list'),

  // RGPD
  // postRgpdConsentLog: getApiUrl('/api/public/rgpdConsentLogs'),

  // Authentification
  // postUserAuthentication: getApiUrl('/auth'),

  // Vidéos & Catalogues
  // getCatalogInfos: getApiUrl('/api/public/video-categories'),
  // getVideosInfos: getApiUrl('/api/videos'),
  // getVideoSetsInfos: getApiUrl('/api/video_sets'),
  // getCategoriesInfos: getApiUrl('/api/video_categories'),
  // patchVideo: getApiUrl('/api/videos/{id}'),
  // postVideo:                              getApiUrl('/api/videos'),
  // getOneVideoInfos:                       getApiUrl('/api/videos/{id}'),
  // patchVideo2:                            getApiUrl('/api/patchvideo'),
  // patchVideoVisibility:                   getApiUrl('/api/patchvideovisibility/{id}'),
  // createVideoCategory:                    getApiUrl('/api/video_categories'),
  // patchVideoCategory:                     getApiUrl('/api/video_categories/{id}'),

  // Broadcasting
  // getBroadcastingChannelStatistics:       getApiUrl('/api/public/broadcasting-channel-statistics'),
  // getBroadcastingChannelPackageInfos:     getApiUrl('/api/public/broadcasting-channel-package'),
  // addBroadcastedVideo:                    getApiUrl('/api/broadcasted_videos'),
  // deleteBroadcastedVideo:                 getApiUrl('/api/broadcasted_videos/{id}'),
  // updateBroadcastedVideo:                 getApiUrl('/api/broadcasted_videos/{id}'),
  // archivedBroadcastedVideo:               getApiUrl('/api/archived_broadcasted_videos'),

  // Géolocalisation IP
  // creationIpAddressGeolocation:           getApiUrl('/api/public/ip_address_geolocation_creation'),
  // checkIpAddressGeolocation:              getApiUrl('/api/public/ip_address_geolocation_check'),
  // getLastCustomerFrontEventsForIpAddress: getApiUrl('/api/public/last_customer_front_events_for_ip_address'),
  // getViewingLogs:                         getApiUrl('/api/public/video_viewing_logs'),
};
 



const accountUrl = "/compte";

export const INTERNAL_LINKS: Record<string, string> = {
  Home                      : "/",
  Login                     : "/connexion",           
  Account                   : `${accountUrl}`,
  Account_MyAccount         : `${accountUrl}/#mon-compte`,
  Account_Subscription      : `${accountUrl}/#abonnements-et-services`,
  Account_Payments          : `${accountUrl}/#informations-de-paiement`,
  Subscription              : "/abonnement",
  Program                   : "/grille",
  Download                  : "/telechargement",
  Club                      : "/club",
  PasswordReset             : "/reinitialisation-mot-de-passe",
  EmailReset                : "/reinitialisation-email",
  PaymentFail               : "/echec-paiement",
  PaymentSuccess            : "/confirmation-paiement",
  LegalNotice               : "/mentions-legales",
  TermsOfService            : "/conditions-generales-d-utilisation",
  CookiesInformation        : "/notice-d-information-sur-les-cookies",
  PersonnalDatasInformation : "/notice-d-information-sur-les-donnees-personnelles",
  Logo_Visa                 : "/images/logo_Visa_50.png",
  Logo_Mastercard           : "/images/logo_Mastercard_50.png",
  Logo_Carte_bleue          : "/images/logo_Carte_bleue_50.png",
  Logo_PayPal               : "/images/logo_PayPal_50.png",
};

export const WWW_URLS: Record<string, string> = Object.fromEntries(
  Object.entries(INTERNAL_LINKS).map(([key, value]) => [key, `${URLS[getMode()]['WWW_BASE']}${value}`])
);

WWW_URLS.FrontServer            = `${URLS[getMode()]['WWW_BASE']}/`
WWW_URLS.ApiServer              = `${URLS[getMode()]['API_BASE']}/`
WWW_URLS.MediaServer            = `${URLS[getMode()]['MEDIA_BASE']}/`
WWW_URLS.ThumbnailSalesCampaign = `${URLS[getMode()]['MEDIA_BASE']}/SalesCampaign/`
WWW_URLS.ThumbnailChannel       = `${URLS[getMode()]['MEDIA_BASE']}/BroadcastingChannels/`
WWW_URLS.Thumbnail              = `${URLS[getMode()]['MEDIA_BASE']}/Vignettes/`
WWW_URLS.Sound                  = `${URLS[getMode()]['MEDIA_BASE']}/Sounds/`
WWW_URLS.Video                  = `${URLS[getMode()]['MEDIA_BASE']}/Videos/`
WWW_URLS.ProductThumbnail       = `${URLS[getMode()]['MEDIA_BASE']}/Boutique/`
WWW_URLS.Icon                   = `${URLS[getMode()]['ICON_BASE']}/images/icons/`
WWW_URLS.customer_front         = `${URLS[getMode()]['CUSTOMER_FRONT_BASE']}`
WWW_URLS.portal_front           = `${URLS[getMode()]['PORTAL_FRONT_BASE']}`
WWW_URLS.ProductControlRoom     = `${URLS[getMode()]['WWW_BASE']}/webrtc`
WWW_URLS.BetatestWebsite        = `${URLS[getMode()]['WWW_BETA_BASE']}`
WWW_URLS.broadcastingServer     = `${URLS[getMode()]['CAST_BASE']}`


